export const zh = {
  common: {
    loading: '加载中...',
    email: '邮箱地址',
    emailRequired: '请输入邮箱地址！',
    emailValid: '请输入有效的邮箱地址！',
    password: '密码',
    passwordRequired: '请输入密码！',
    passwordMin: '密码长度不能小于6位！',
    confirmPassword: '确认密码',
    confirmPasswordRequired: '请确认密码！',
    confirmPasswordNotMatch: '两次输入的密码不一致！',
    phone: '手机号',
    phoneRequired: '请输入手机号！',
    phoneValid: '请输入有效的手机号！',
    code: '验证码',
    codeRequired: '请输入验证码！',
    back: '返回',
    and: '和',
    agreementUser: '《用户协议》',
    agreementPrivacy: '《隐私协议》',
    submit: '提交',
    contact: '联系方式',
    feedback: '反馈',
    success: '操作成功',
    fail: '操作失败',
    nickname: '昵称',
    avatar: '头像',
    language: '选择界面语言',
    logout: '退出登录',
    privacy: '隐私协议',
    manual: '使用说明',
    userAgreement: '用户协议',
    ok: '确定',
    move: '移动',
    cancel: '取消',
    delete: '删除',
    deleteForever: '永久删除',
    edit: '编辑',
    warning: '警告',
    info: '提示',
    yes: '是',
    no: '否',
    copy: '复制',
    export: '导出',
    save: '保存',
    close: '关闭',
    empty: '暂无数据',
    input: '请输入',
    name: '名称',
    newName: '新名称',
    unchanged: '未发生变化',
    updateSuccess: '更新成功',
    updateFail: '更新失败，请稍后重试',
    deleteSuccess: '删除成功',
    deleteFail: '删除失败，请稍后重试',
    confirmDelete: '确认删除',
    confirm: '确认',
    know: '知道了',
    file: '文件',
    sessionExpired: '登录已过期，请重新登录',
    noPermission: '没有权限访问该资源',
    resourceNotFound: '请求的资源不存在',
    methodNotAllowed: '请求方法不允许',
    serverError: '服务器错误，请稍后重试',
    networkError: '网络错误，请检查您的网络连接',
    requestConfigError: '请求配置错误',
    requestFailed: '请求失败',
    fileName: '文件名',
    fileType: '文件类型',
    fileList: '文件记录',
    operation: '操作',
    rename: '重命名',
    sync: '同步',
    detail: '详情',
    download: '下载',
    retry: '重试',
    start: '开始',
    stop: '停止',
    continue: '继续',
    finish: '完成',
    tip: '提示',
    more: '更多',
    search: '搜索',
    moveFolder: '移至文件夹',
    moveRecycle: '移至回收站',
    recover: '恢复',
    myFolder: '我的文件夹',
    createNewFolder: '+ 新建文件夹',
  },
  aside: {
    allFile: '全部文件',
    allTypes: '全部类型',
    allFolder: '文件夹',
    noFolder: '暂无文件夹',
    setting: '偏好设置',
    helpFeed: '帮助与反馈',
    code: '二维码',
    scanCode: '扫码下载APP',
  },
  login: {
    title: '账号登录',
    emailLogin: '邮箱登录',
    phoneLogin: '手机号登录',
    loginBtn: '登录',
    forgot: '忘记密码',
    noAccount: '还没有账号？',
    register: '立即注册',
    agreementPrefix: '继续使用表示您已阅读并接受',
    loginSuccess: '登录成功！',
    loginFail: '登录失败，请检查用户名和密码！',
    getCode: '获取验证码',
    codeSent: '验证码已发送',
    codeFail: '验证码发送失败，请稍后重试！',
    resend: '重新发送',
    resendIn: '秒后重新发送',
  },
  profile: {
    avatar: '头像',
    nickname: '昵称',
    personalInfo: '个人信息',
    language: '选择显示语言',
    logout: '退出登录',
    privacy: '隐私协议',
    manual: '使用说明',
    userAgreement: '用户协议',
  },
  register: {
    title: '注册账户',
    agree: '我已阅读并同意',
    submit: '确认',
    agreeTip: '请同意用户协议和隐私政策！',
    success: '注册成功！请登录',
    fail: '注册失败，请稍后重试！',
  },
  resetPassword: {
    title: '修改密码',
    code: '请输入收到的验证码',
    codeRequired: '请输入收到的验证码！',
    getCode: '获取验证码',
    codeSent: '验证码已发送，请查收邮箱',
    codeFail: '验证码发送失败，请稍后重试！',
    newPassword: '请输入新密码！',
    submit: '确认修改',
    emailTip: '请先输入邮箱！',
    success: '密码修改成功，请重新登录！',
    fail: '密码修改失败，请稍后重试！',
  },
  feedback: {
    title: '反馈',
    contentLabel: '您遇到的问题或建议',
    contentPlaceholder: '请详细描述您遇到的问题或建议...',
    contentRequired: '请输入详细内容',
    typeLabel: '问题类型',
    typeLabelHolder: '请选择反馈类型',
    typeRequired: '请输入反馈标题',
    typeBug: '功能异常',
    typeFeature: '功能建议',
    typeUI: '界面优化',
    typePerformance: '性能问题',
    typeOther: '其他',
    contactLabel: '联系方式',
    contactRequired: '请输入联系方式',
    contactPlaceholder: '请输入您的联系方式',
    submit: '提交反馈',
    success: '感谢您的反馈！',
    fail: '提交失败，请稍后重试',
  },
  file: {
    welcome: '欢迎使用悦会WEB!',
    listTitle: '文件记录',
    recycle: '回收站',
    deleteTitle: '删除文件',
    deleteContent: '此文件将被永久删除且无法恢复，是否确认删除？',
    deleteOk: '删除',
    deleteCancel: '取消',
    deleteSuccess: '文件删除成功',
    deleteFail: '删除文件失败，请稍后重试',
    transcription: '转写内容',
    welcomeTranscription: '欢迎体验人工智能转写功能!',
    generate: '生成',
    transcribing: '转写正在生成中...',
    transcribingTip: '这将需要几分钟，完成后将自动显示结果，您可以离开此页面或在此等待',
    transcribeFail: '转写生成失败！',
    transcribeFailTip: '非常遗憾，转写操作未能成功完成，建议您再次进行生成尝试',
    regenerate: '重新生成',
    regenerateTrans: '是否确认重新尝试生成当前音频的转写内容?',
    regenerateSummary: '是否确认重新尝试生成当前音频的总结内容?',
    summaryGenerating: '总结正在生成中...',
    summaryGeneratingTip: '转写结果已生成，总结生成还需几分钟，您可以继续等待或者查看转写内容',
    viewTranscription: '查看转写结果',
    summaryFail: '总结生成失败',
    summaryFailTip: '很抱歉，总结生成失败，请稍后再试',
    selectTemplate: '选择模板',
    selectTemplateLanguage: '精转语言',
    meetingSummary: '会议纪要',
    topic: '主题',
    todo: '代办事项',
    interview: '采访/面试',
    qa: '问答',
    opinion: '观点',
    speech: '演讲',
    summary: '摘要',
    question: '问题',
    startTranscribing: '正在开始转写...',
    transcribeStarted: '转写已开始，请稍后查看结果',
    transcribeFailRetry: '转写失败，请稍后重试',
    transcribe: '转写',
    retranscribe: '重新转写',
    resummarize: '重新总结',
    rename: '重命名',
    AddFolder: '创建文件夹',
    addFolderPlaceholder: '请输入文件夹名称',
    renamePlaceholder: '请输入新的文件名',
    renameOk: '确认',
    renameCancel: '取消',
    renameSuccess: '文件名更新成功',
    createFolderFail: '文件夹创建失败',
    createFolderSuccess: '文件夹创建成功',
    renameFail: '文件名更新失败，请稍后重试',
    renameUnchanged: '文件名无变化',
    renameRequired: '请输入新的文件名',
    delete: '删除',
    copyTranscription: '复制转写内容',
    copySummary: '复制总结',
    exportTranscription: '导出转写内容',
    exportSummary: '导出总结',
    exportMindmap: '导出思维导图',
    exportMp3: '导出音频',
    copy: '复制',
    export: '导出',
    empty: '内容为空',
    exportSuccess: '导出成功',
    exportFail: '导出失败',
    syncTip: '了解如何同步数据',
    syncTipDesc: '如需在此查看您的数据，请打开最新版的悦会 APP，并启用悦会 PRIVATE CLOUD。这将安全地备份您的数据，并同步至云端，方便您通过各种设备访问。',
    copySuccess: '内容已复制到剪贴板',
    dateTime: '日期时间',
    location: '地点',
    attendees: '与会人员',
    meetingRecord: '会议记录',
    nextStep: '下一步',
    interviewer: '采访人',
    conclusion: '结论',
    speaker: '主讲人',
    abstract: '摘要',
    keyPoints: '要点',
    questions: '问题',
    assignments: '作业',
    showList: '显示列表',
    hideList: '隐藏列表',
    hideTranscript: '隐藏转写',
    showTranscript: '显示转写',
    summaryz: '总结',
    mind: '思维导图',
    zd: '自动适配',
    zdTag1: '自动适配',
    zx: '咨询',
    zxTag1: '成果',
    zxTag2: '决策',
    hb: '汇报',
    hbTag1: '进展',
    hbTag2: '问题',
    tl: '讨论',
    tlTag1: '结论',
    tlTag2: '要点',
    bj: '课堂笔记',
    bjTag1: '知识点',
    bjTag2: '讲解',
    px: '培训',
    pxTag1: '关键点',
    pxTag2: '注意',
    xq: '需求评估',
    xqTag1: '痛点',
    xqTag2: '期待',
    moveSuccess: '移动成功',
    moveFail: '移动失败',
    moveSelectFile: '请选择要移动文件夹',
    notCate: '未分类',
    recoverSuccess: '移动成功',
    recoverFail: '移动失败',
    editFolder: '编辑文件夹',
    folderNameUnchanged: '文件夹名称未变化',
    folderExists: '文件夹已存在',
    invalidCharacters: '名称包含非法字符,请修改后重试',
    updateFolderSuccess: '文件夹更新成功',
    updateFolderFail: '文件夹更新失败',
    deleteFolderTips: '此文件夹将被永久删除，文件夹中的文件会被移入回收站，请确认是否删除？',
    insufficientBalance: '余额不足',
    insufficientBalanceMessage: '转写时长不足，无法完成转录。',
    zoomIn: '放大',
    zoomOut: '缩小',
    fitView: '恢复视图',
    editTitle: '点击编辑标题',
    editContent: '点击编辑内容',
    titlePlaceholder: '输入标题...',
    contentPlaceholder: '输入内容，或使用 / 命令插入模块',
    saving: '保存中...',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    titleSaveSuccess: '标题已更新',
    contentSaveSuccess: '内容已更新',
    sessionExpired: '会话已过期，请重新登录',
  },
  blockNoteEditor: {
    heading2: '二级标题',
    heading3: '三级标题',
    heading4: '四级标题',
    quote: '引用',
    bulletList: '无序列表',
    numberedList: '有序列表',
  },
  vip: {
    lock: '解锁免费会员',
    lockDesc: '绑定设备激活会员权益',
    lockNowBtnText: '立即解锁',
    starVipName: '初级会员',
    proVipName: '中级会员',
    unlimitedVipName: '高级会员',
    transTimeName: '转写时长包',
    timeReset: '重置',
    timeEnd: '到期',
    usedUp: '已用完',
    minutesLeft: '剩余 {count} 分钟',
    lockTitle: '解锁免费会员',
    lockSubTitle: '请打开悦会 APP 并绑定设备，即可激活会员权益',
    lockRights1: '每月免费转写时长',
    lockRights2: '多种场景模板总结',
    lockRights3: '区分不同说话人',
    lockRights4: '智能降噪，提升音频回放效果',
    lockRights5: '支持多种导出格式',
  }
}; 